import 'lazysizes';
import objectFitImages from 'object-fit-images';

import './in-view';
import './menu';
import './slideshow';
import './video';
import './slider';
import './lightbox';
import './expanders';
import './marquees';
import './subnav';
import './header-nav';
import './text-marquee';

objectFitImages();

// function throttle(callback, limit, arg) {
//   let wait = false; // Initially, we're not waiting
//   return function () {
//     // We return a throttled function
//     if (!wait) {
//       // If we're not waiting
//       callback.call(this, arg); // Execute users function
//       wait = true; // Prevent future invocations
//       setTimeout(function () {
//         // After a period of time
//         wait = false; // And allow future invocations
//       }, limit);
//     }
//   };
// }

function setupVisibilityToggles() {
  /**
   * Initialize aria visibility toggles.
   *
   * Usage:
   *    <button aria-expanded="false" aria-controls="myDropdown">Toggle</button>
   *    <div id="myDropdown" aria-hidden="true">Dropdown</div>
   */
  document.querySelectorAll('[aria-controls]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const id = el.getAttribute('aria-controls');
      const controlled = document.getElementById(id);
      const open = controlled.getAttribute('aria-hidden') !== 'false';

      controlled.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((el) => {
        el.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      e.preventDefault();
    });
  });

  /**
   * Lazy loading fallback
   */
  if ('loading' in HTMLImageElement.prototype) {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach((img) => {
      if (img.dataset.src !== 'undefined') img.src = img.dataset.src;
      if (img.dataset.srcset !== 'undefined') img.srcset = img.dataset.srcset;
      img.classList.remove('blur-up');
      img.classList.remove('lazyload');
    });
  } else {
    // Dynamically import the LazySizes library
    const script = document.createElement('script');
    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
    document.body.appendChild(script);
  }
}

function getHeaderHeight() {
  const header = document.querySelector('.js-header');
  return parseInt(header.dataset.pxHeight);
}

function checkHeaderScroll(headerHeight) {
  if (window.scrollY > headerHeight) {
    document.querySelector('#main').classList.add('is-scrolled-off-top');
  } else {
    document.querySelector('#main').classList.remove('is-scrolled-off-top');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setupVisibilityToggles();

  const headerHeight = getHeaderHeight();

  document.addEventListener('scroll', function () {
    checkHeaderScroll(headerHeight);
  });

  checkHeaderScroll();

  const htmlEl = document.querySelector('html');
  htmlEl.classList.add('has-js-app');

  document.querySelectorAll('.block-link').forEach((el) => {
    el.addEventListener('click', function (e) {
      el.querySelector('a').click();
    });
  });
});
